import '../utilities/scrollIntoViewIfNeeded.js';
import { useTheme } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { useRef, createElement } from 'react';
import { ellipsis } from '../utilities/ellipsis.js';
import { _ as _objectWithoutProperties, b as _extends, a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import { lighten } from '@vebox/etui-colors';
import { FormItem } from '../FormItem/FormItem.js';
import '../InputLabel/InputLabel.js';
import '../InputAddon/InputAddon.js';
import 'react-select';
import Control from './Control.js';
import ValueContainer from './ValueContainer.js';
import IndicatorsContainer from './IndicatorsContainer.js';
import DropdownIndicator from './DropdownIndicator.js';
import Menu from './Menu.js';
import CreatableSelect from 'react-select/creatable';

const _excluded = ["name", "size", "label", "options", "readOnly", "disabled", "defaultOpen", "defaultValue", "startInputAddon", "endInputAddon", "createOptionPosition", "allowCreateWhileLoading", "searchable", "onChange", "formatCreateLabel", "isValidNewOption", "getNewOptionData", "onCreateOption", "elRef", "styles", "tabIndex"];
function SelectInputCreatable(_ref) {
  let {
      name,
      size = 'default',
      label,
      options,
      readOnly = false,
      disabled,
      defaultOpen,
      defaultValue,
      startInputAddon,
      endInputAddon,
      createOptionPosition = 'last',
      allowCreateWhileLoading = false,
      searchable = false,
      onChange,
      formatCreateLabel,
      isValidNewOption,
      getNewOptionData,
      onCreateOption,
      elRef,
      styles = {},
      tabIndex
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const theme = useTheme();
  const menuRef = useRef(null);
  const handleOnChange = (value, actionMeta) => {
    if (onChange) {
      onChange(value, actionMeta);
    }
  };
  const handleCreateOption = value => {
    if (onCreateOption) {
      onCreateOption(value);
    }
  };
  const components = {
    Placeholder: () => null,
    IndicatorSeparator: () => null,
    Control,
    IndicatorsContainer,
    ValueContainer,
    DropdownIndicator,
    Menu
  };
  return /*#__PURE__*/createElement(FormItem, styles.root, /*#__PURE__*/createElement(CreatableSelect, _extends({
    id: name,
    inputId: `${name}-input`,
    name: name,
    placeholder: label,
    components: components,
    styles: {
      option: (_, {
        isFocused,
        isSelected
      }) => {
        return _objectSpread2(_objectSpread2({}, theme.typography.button), {}, {
          borderBottom: `1px solid ${theme.palette.divider}`,
          height: '100%',
          paddingTop: theme.spacing.xs,
          paddingBottom: theme.spacing.xs,
          paddingRight: theme.spacing.xs,
          paddingLeft: theme.spacing.xs,
          backgroundColor: isSelected ? theme.palette.action.hover : isFocused ? lighten(theme.palette.action.hover, 0.5) : 'transparent',
          color: isSelected || isFocused ? theme.palette.primary.main : theme.palette.text.secondary,
          outline: 'none',
          cursor: 'pointer',
          '&:last-child': {
            borderBottom: 0
          },
          '&:hover,:focus': {
            color: theme.palette.primary.main,
            backgroundColor: lighten(theme.palette.action.hover, 0.5)
          }
        });
      },
      input: baseStyles => _objectSpread2(_objectSpread2({}, baseStyles), {}, {
        margin: 0,
        padding: 0,
        paddingBottom: 0,
        paddingTop: 0,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightBold,
        color: theme.palette.text.primary,
        caretColor: theme.palette.text.primary
      }),
      menu: (baseStyles, {
        selectProps: {
          menuIsOpen,
          customStyles
        }
      }) => _objectSpread2(_objectSpread2({}, baseStyles), {}, {
        position: 'absolute',
        top: 'calc(100% - 1px)',
        color: theme.palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.fontSizeBase,
        fontWeight: theme.typography.fontWeightRegular,
        boxShadow: theme.shadows[4],
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: `${theme.shape.borderRadius}px`,
        borderBottomRightRadius: `${theme.shape.borderRadius}px`,
        margin: 0,
        borderColor: menuIsOpen ? theme.palette.grey[100] : theme.palette.grey[60],
        borderRightWidth: '1px',
        borderBottomWidth: '1px',
        borderLeftWidth: '1px',
        borderTopWidth: 0,
        borderStyle: 'solid',
        textAlign: 'left',
        zIndex: theme.zIndex.selectInput
      }, customStyles.menu),
      menuList: (baseStyles, {
        selectProps: {
          customStyles
        }
      }) => _objectSpread2(_objectSpread2({}, baseStyles), {}, {
        padding: theme.spacing.xs,
        position: 'relative'
      }, customStyles.menuList),
      singleValue: () => _objectSpread2({
        margin: 0,
        position: 'absolute',
        width: '100%',
        lineHeight: 'normal',
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightBold,
        cursor: 'default'
      }, ellipsis())
    },
    allowCreateWhileLoading: allowCreateWhileLoading,
    options: options,
    readOnly: readOnly,
    disabled: disabled,
    isDisabled: disabled || readOnly,
    defaultMenuIsOpen: defaultOpen,
    defaultValue: defaultValue,
    isSearchable: searchable,
    startInputAddon: startInputAddon,
    endInputAddon: endInputAddon,
    onCreateOption: handleCreateOption,
    onChange: handleOnChange,
    createOptionPosition: createOptionPosition,
    customTheme: theme,
    customStyles: styles,
    size: size,
    ref: elRef,
    isClearable: false,
    tabIndex: typeof tabIndex === 'string' ? parseInt(tabIndex, 10) : tabIndex,
    menuRef: menuRef
  }, rest)));
}

export default SelectInputCreatable;
